export default __webpack_public_path__ + "static/media/ResultsPage_01.38d29eb9.jpg";